import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { _GraphQueryableCollection, _GraphQueryableInstance, graphInvokableFactory } from "@pnp/graph/graphqueryable";
import { defaultPath, deleteable, getById, updateable } from "@pnp/graph/decorators";
import { graphPost } from "@pnp/graph";
import { body } from "@pnp/odata";
/**
 * Outlook
 */
var _Outlook = /** @class */ (function (_super) {
    __extends(_Outlook, _super);
    function _Outlook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_Outlook.prototype, "masterCategories", {
        get: function () {
            return MasterCategories(this);
        },
        enumerable: false,
        configurable: true
    });
    return _Outlook;
}(_GraphQueryableInstance));
export { _Outlook };
export var Outlook = graphInvokableFactory(_Outlook);
/**
 * Describes an Outlook Category instance
 */
var _OutlookCategory = /** @class */ (function (_super) {
    __extends(_OutlookCategory, _super);
    function _OutlookCategory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _OutlookCategory = __decorate([
        deleteable(),
        updateable()
    ], _OutlookCategory);
    return _OutlookCategory;
}(_GraphQueryableInstance));
export { _OutlookCategory };
export var OutlookCategory = graphInvokableFactory(_OutlookCategory);
/**
 * Categories
 */
var _MasterCategories = /** @class */ (function (_super) {
    __extends(_MasterCategories, _super);
    function _MasterCategories() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds a new event to the collection
     *
     * @param properties The set of properties used to create the event
     */
    _MasterCategories.prototype.add = function (properties) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, graphPost(this, body(properties))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, {
                                data: data,
                            }];
                }
            });
        });
    };
    _MasterCategories = __decorate([
        defaultPath("masterCategories"),
        getById(OutlookCategory)
    ], _MasterCategories);
    return _MasterCategories;
}(_GraphQueryableCollection));
export { _MasterCategories };
export var MasterCategories = graphInvokableFactory(_MasterCategories);
//# sourceMappingURL=types.js.map